import React from 'react';
import ListEditor from './ListEditor';
import ObjectEditor from './ObjectEditor';
import './DynamicStudyForm.css';

// 템플릿 schema.fields 기반 타입별 동적 폼 렌더링
// fields: TemplateField[]
// value: Record<string, unknown>
// onChange: (key, value) => void
const DynamicStudyForm = ({ fields = [], value = {}, onChange }) => {
  if (!fields.length) {
    return <p className="dsf-empty">선택된 템플릿에 필드가 없습니다.</p>;
  }

  return (
    <div className="dsf-container">
      {fields.map((field) => (
        <div key={field.key} className="dsf-field">
          <label className="dsf-label">
            {field.label}
            {field.required && <span className="dsf-required"> *</span>}
          </label>
          {renderField(field, value[field.key], (v) => onChange(field.key, v))}
        </div>
      ))}
    </div>
  );
};

const renderField = (field, fieldValue, onChange) => {
  switch (field.type) {
    case 'string':
      return (
        <textarea
          className="dsf-textarea"
          value={fieldValue ?? ''}
          onChange={(e) => onChange(e.target.value)}
          rows={3}
          placeholder={`${field.label} 입력`}
        />
      );

    case 'number':
      return (
        <input
          type="number"
          className="dsf-input"
          value={fieldValue ?? ''}
          min={field.min !== undefined ? field.min : undefined}
          max={field.max !== undefined ? field.max : undefined}
          onChange={(e) => onChange(e.target.value === '' ? '' : Number(e.target.value))}
          placeholder={field.min !== undefined || field.max !== undefined
            ? `${field.min ?? ''} ~ ${field.max ?? ''}`
            : `${field.label} 입력`}
        />
      );

    case 'boolean':
      return (
        <label className="dsf-checkbox-label">
          <input
            type="checkbox"
            checked={!!fieldValue}
            onChange={(e) => onChange(e.target.checked)}
          />
          <span>{field.label}으로 등록</span>
        </label>
      );

    case 'date':
      return (
        <input
          type="date"
          className="dsf-input dsf-date"
          value={fieldValue ?? ''}
          onChange={(e) => onChange(e.target.value)}
        />
      );

    case 'list':
      return (
        <ListEditor
          value={Array.isArray(fieldValue) ? fieldValue : []}
          onChange={onChange}
          itemType={field.item_type || 'string'}
        />
      );

    case 'object':
      return (
        <ObjectEditor
          fields={field.fields || []}
          value={typeof fieldValue === 'object' && fieldValue !== null ? fieldValue : {}}
          onChange={onChange}
        />
      );

    default:
      return (
        <input
          type="text"
          className="dsf-input"
          value={fieldValue ?? ''}
          onChange={(e) => onChange(e.target.value)}
          placeholder={`${field.label} 입력`}
        />
      );
  }
};

export default DynamicStudyForm;
